<template>
    <!--
    Свойства компонента:
        text.................текст кнопки
        disabled.............true - кнопка заблокирована, false - кнопка активна (если не указать то кнопка активна)
        type.................button_main - желтая; button_addit - серая; button_addit_blue - голубая
        spinner..............активировать спиннер (по умолчанию false) сработает через 0.5 секунды после чего кнопка не активна,
                             для возвращения кнопки в активное состояние передать true
    События компоеннта:
        @click....................клик по кнопке
 -->
    <div
        ref="button_wrapper"
        class="square-button"
        :class="disabled ? 'disabled' : type"
        :style="waiting ? {'width': width + 'px'} : ''"
        @click="click()"
    >
        <template v-if="waiting">
            <svg
                class="spinner"
                viewBox="0 0 50 50"
            >
                <circle
                    class="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke-width="3"
                />
            </svg>
        </template>
        <template v-else>
            <span>{{ text }}</span>
        </template>
    </div>
</template>
<script>
export default {
    name: 'SquareButton',
    props: {
        text: {
            type: String,
            default: 'no name'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['click'],
    data () {
        return {
            waiting: false,
            timer: null,
            width: ''
        }
    },
    computed: {
        type: function () {
            return this.$attrs.type || 'button_main'
        },
        spinner: function () {
            return this.$attrs.spinner || false
        }
    },
    watch: {
        spinner (val) {
            if (val === false) {
                this.waiting = false
                clearTimeout(this.timer)
            }
        }
    },
    mounted () {
        this.width = this.$refs.button_wrapper.offsetWidth;
    },
    methods: {
        click () {
            if (this.waiting === true || this.disabled) return
            this.$emit('click')
            this.timer = setTimeout(() => {
                if (this.spinner === true) {
                    this.waiting = true;
                }
            }, 500)
        }
    }
}
</script>
<style scoped>
    span {
        white-space: nowrap;
    }
    div {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 40px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 500;
        height: 38px;
        cursor: pointer;
        user-select: none;
        transition: .2s ease-in-out;
    }
    .square-button {
      border-radius: 28px;
    }
    .button_main {
        background-color: #F8DB78;
    }
    .button_main:hover {
        background-color: #FFD854;
        opacity: 0.8;
    }
    .button_main:active {
        background-color: #FFD750;
        opacity: 1;
    }
    .button_addit {
        background-color: #E2E2E2;
    }
    .button_addit:hover {
        background-color: #EEEEEE;
    }
    .button_addit:active {
        background-color: #DDDDDD;
    }
    .button_addit_blue {
        background-color: var(--primary-blue);
    }
    .button_addit_blue:hover {
        background-color: var(--primary-blue);
        opacity: 0.8;
    }
    .button_addit_blue:active {
        background-color: #D5E7F9;
        opacity: 1;
    }
    .button_addit_blue span {
      color: var(--white);
    }
    .disabled {
        background: rgba(0,0,0,0.1);
        color: rgba(0,0,0,0.2);
        cursor: default;
    }
    .spinner {
        position: absolute;
        animation: rotate 2s linear infinite;
        z-index: 2;
        width: 30px;
        height: 30px;
    }
    .spinner .path {
        stroke: #fff;
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
</style>
